import { Box, Text } from '@air/zephyr';
import Image from 'next/image';
import Link from 'next/link';

import { ImageData, LimitedAgencyData } from '~/old-marketing/components/types/custom-types';

export interface CuratedAgencyCardProps extends Pick<LimitedAgencyData, 'name' | 'slug'> {
  image?: ImageData;
}

export const CuratedAgencyCard = ({ image, name, slug }: CuratedAgencyCardProps) => {
  return (
    <Box as="article" tx={{ position: 'relative', backgroundColor: 'pigeon025', borderRadius: 8, overflow: 'hidden' }}>
      {image && image.height && image.width && (
        <Box
          tx={{
            position: 'relative',
            pb: '60%',

            img: {
              objectFit: 'cover',
            },
          }}
        >
          <Image layout="fill" src={image.url} />
        </Box>
      )}

      <Text
        as="h4"
        tx={{ py: 12, color: 'pigeon700', fontWeight: 'bold', textAlign: 'center' }}
        variant="text-ui-14-uppercase"
      >
        <Link href={`/agencies/${slug}`} passHref>
          <Box
            as="a"
            tx={{
              color: 'inherit',
              textDecoration: 'none',

              /**
               * This makes the entire card clickable for seeing eye users and
               * prevent screen readers from reading everything within the card
               * as a link.
               *
               * @see https://inclusive-components.design/cards/
               */
              '&:after': {
                content: '""',
                position: 'absolute',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
              },
            }}
          >
            {name}
          </Box>
        </Link>
      </Text>
    </Box>
  );
};
